<div class="mb-4 text-center" ngxViewer2 [viewerOptions]="viewerOptions" (viewerViewed)="onViewed($event)">
  <img class="image-preview" [src]="data.src" [alt]="data.alt" >
</div>
